import { FunctionComponent } from 'react';
import angle_right_solid from 'src/shared/material_icons/hardware/keyboard_arrow_right.svg';
import arrow_left_solid from 'src/shared/material_icons/navigation/arrow_back.svg';
import { default as arrow_right_solid, default as arrow_right_solid_white } from 'src/shared/material_icons/navigation/arrow_forward.svg';
import bell_solid from 'src/shared/material_icons/social/notifications.svg';
import book_open_solid from 'src/shared/material_icons/maps/menu_book.svg';
import cart_arrow_down_solid from 'src/shared/material_icons/action/add_shopping_cart.svg';
import chart_bar_solid from 'src/shared/material_icons/editor/bar_chart.svg';
import cog_solid from 'src/shared/material_icons/action/settings.svg';
import cogs_solid from 'src/shared/material_icons/action/settings.svg';
import coins_solid from 'src/shared/material_icons/editor/monetization_on.svg';
import comment_dots from 'src/shared/material_icons/communication/chat.svg';
import comment from 'src/shared/material_icons/communication/chat_bubble.svg';
import comments_dollar_solid from 'src/shared/material_icons/action/paid.svg';
import credit_card from 'src/shared/material_icons/action/credit_card.svg';
import cube_solid from 'src/shared/material_icons/action/view_in_ar.svg';
import cubes_solid from 'src/shared/material_icons/action/view_in_ar.svg';
import customizable_products_menu_icon from 'src/shared/material_icons/content/inventory_2.svg';
import elementor from 'src/shared/material_icons/legacy/elementor.svg';
import envelope from 'src/shared/material_icons/content/mail.svg';
import file_archive from 'src/shared/material_icons/file/folder_zip.svg';
import file_csv_solid from 'src/shared/material_icons/action/description.svg';
import file_image from 'src/shared/material_icons/image/image.svg';
import file_invoice_solid from 'src/shared/material_icons/image/receipt_long.svg';
import file_pdf from 'src/shared/material_icons/image/picture_as_pdf.svg';
import fill_drip_solid from 'src/shared/material_icons/editor/format_color_fill.svg';
import folder_plus_solid from 'src/shared/material_icons/file/create_new_folder.svg';
import fonticons from 'src/shared/material_icons/maps/category.svg';
import globe_europe_solid from 'src/shared/material_icons/action/language.svg';
import google from 'src/shared/material_icons/social/public.svg';
import grip_horizontal_solid from 'src/shared/material_icons/action/drag_indicator.svg';
import home_solid from 'src/shared/material_icons/action/home.svg';
import hotjar from 'src/shared/material_icons/legacy/hotjar.svg';
import icon_3d_rotation from 'src/shared/material_icons/action/3d_rotation.svg';
import icons_solid from 'src/shared/material_icons/maps/category.svg';
import info_circle_solid from 'src/shared/material_icons/action/info.svg';
import key_solid from 'src/shared/material_icons/communication/vpn_key.svg';
import list_alt_solid from 'src/shared/material_icons/action/view_list.svg';
import mail_bulk_solid from 'src/shared/material_icons/navigation/campaign.svg';
import money_bill_wave_solid from 'src/shared/material_icons/navigation/payments.svg';
import pencil_ruler_solid from 'src/shared/material_icons/maps/design_services.svg';
import portrait_solid from 'src/shared/material_icons/image/portrait.svg';
import print_solid from 'src/shared/material_icons/action/print.svg';
import question_circle_solid from 'src/shared/material_icons/action/help.svg';
import quote_left_solid from 'src/shared/material_icons/editor/format_quote.svg';
import readme from 'src/shared/material_icons/legacy/readme.svg';
import robot_2 from 'src/shared/material_icons/hardware/smart_toy.svg';
import server_solid from 'src/shared/material_icons/action/dns.svg';
import shapes_solid from 'src/shared/material_icons/editor/format_shapes.svg';
import shopping_cart_solid from 'src/shared/material_icons/action/shopping_cart.svg';
import signature_solid from 'src/shared/material_icons/editor/draw.svg';
import sliders_h_solid from 'src/shared/material_icons/image/tune.svg';
import store_alt_solid from 'src/shared/material_icons/places/storefront.svg';
import swatchbook_solid from 'src/shared/material_icons/image/style.svg';
import table_solid from 'src/shared/material_icons/editor/table_chart.svg';
import tags_solid from 'src/shared/material_icons/device/sell.svg';
import terminal_solid from 'src/shared/material_icons/action/terminal.svg';
import th_list_solid from 'src/shared/material_icons/action/view_list.svg';
import times_solid from 'src/shared/material_icons/navigation/close.svg';
import tools_solid from 'src/shared/material_icons/action/build.svg';
import trepunti from 'src/shared/material_icons/navigation/more_vert.svg';
import tshirt_solid from 'src/shared/material_icons/places/checkroom.svg';
import user_alt_slash_solid from 'src/shared/material_icons/social/person_off.svg';
import { default as user_alt_solid, default as users_solid } from 'src/shared/material_icons/action/account_circle.svg';
import user_tie_solid from 'src/shared/material_icons/social/person.svg';
import wand_stars from 'src/shared/material_icons/image/auto_fix_high.svg';
import window_restore from 'src/shared/material_icons/action/open_in_new.svg';
import wpforms from 'src/shared/material_icons/action/dynamic_form.svg';
import dashboard_customize from 'src/shared/material_icons/action/dashboard_customize.svg';
import text_fields from 'src/shared/material_icons/editor/text_fields.svg';
import extension from 'src/shared/material_icons/action/extension.svg';
import shield from 'src/shared/material_icons/content/shield.svg';
import production_quantity_limits from 'src/shared/material_icons/action/production_quantity_limits.svg';
import request_quote from 'src/shared/material_icons/file/request_quote.svg';
import integration_instructions from 'src/shared/material_icons/action/integration_instructions.svg';
import display_settings from 'src/shared/material_icons/action/display_settings.svg';
import logo_zakeke from 'src/shared/svg/logoZakeke';
import Sparkles from '../../../shared/svg/sparkles';

const items: Map<string, FunctionComponent> = new Map();
items.set('angle_right_solid', angle_right_solid);
items.set('bell_solid', bell_solid);
items.set('book_open_solid', book_open_solid);
items.set('cart_arrow_down_solid', cart_arrow_down_solid);
items.set('cog_solid', cog_solid);
items.set('coins_solid', coins_solid);
items.set('credit_card', credit_card);
items.set('grip_horizontal_solid', grip_horizontal_solid);
items.set('home_solid', home_solid);
items.set('key_solid', key_solid);
items.set('pencil_ruler_solid', pencil_ruler_solid);
items.set('readme', readme);
items.set('tools_solid', tools_solid);
items.set('tshirt_solid', tshirt_solid);
items.set('user_alt_slash_solid', user_alt_slash_solid);
items.set('user_alt_solid', user_alt_solid);
items.set('logo_zakeke', logo_zakeke);
items.set('file_invoice_solid', file_invoice_solid);
items.set('arrow_right_solid', arrow_right_solid);
items.set('cogs_solid', cogs_solid);
items.set('comment', comment);
items.set('comment_dots', comment_dots);
items.set('comments_dollar_solid', comments_dollar_solid);
items.set('cube_solid', cube_solid);
items.set('cubes_solid', cubes_solid);
items.set('elementor', elementor);
items.set('file_image', file_image);
items.set('fill_drip_solid', fill_drip_solid);
items.set('folder_plus_solid', folder_plus_solid);
items.set('fonticons', fonticons);
items.set('icons_solid', icons_solid);
items.set('list_alt_solid', list_alt_solid);
items.set('money_bill_wave_solid', money_bill_wave_solid);
items.set('portrait_solid', portrait_solid);
items.set('print_solid', print_solid);
items.set('quote_left_solid', quote_left_solid);
items.set('server_solid', server_solid);
items.set('signature_solid', signature_solid);
items.set('sliders_h_solid', sliders_h_solid);
items.set('table_solid', table_solid);
items.set('terminal_solid', terminal_solid);
items.set('th_list_solid', th_list_solid);
items.set('wpforms', wpforms);
items.set('file_csv_solid', file_csv_solid);
items.set('swatchbook_solid', swatchbook_solid);
items.set('globe_europe_solid', globe_europe_solid);
items.set('file_archive', file_archive);
items.set('shopping_cart_solid', shopping_cart_solid);
items.set('arrow_right_solid_white', arrow_right_solid_white);
items.set('times_solid', times_solid);
items.set('arrow_left_solid', arrow_left_solid);
items.set('store_alt_solid', store_alt_solid);
items.set('trepunti', trepunti);
items.set('question_circle_solid', question_circle_solid);
items.set('info_circle_solid', info_circle_solid);
items.set('envelope', envelope);
items.set('shapes_solid', shapes_solid);
items.set('hotjar', hotjar);
items.set('google', google);
items.set('pdf-preview', file_pdf);
items.set('window-restore', window_restore);
items.set('users_solid', users_solid);
items.set('customizable_products_menu_icon', customizable_products_menu_icon);
items.set('wpforms', wpforms);
items.set('users_solid', users_solid);
items.set('user_tie_solid', user_tie_solid);
items.set('chart_bar_solid', chart_bar_solid);
items.set('mail_bulk_solid', mail_bulk_solid);
items.set('icon_3d_rotation', icon_3d_rotation);
items.set('tags-solid', tags_solid);
items.set('sparkles', Sparkles);
items.set('robot_2', robot_2);
items.set('wand_stars', wand_stars);
items.set('dashboard_customize', dashboard_customize);
items.set('text_fields', text_fields);
items.set('extension', extension);
items.set('shield', shield);
items.set('production_quantity_limits', production_quantity_limits);
items.set('request_quote', request_quote);
items.set('integration_instructions', integration_instructions);
items.set('display_settings', display_settings);

export const GetIcon = (icon: string) => items.get(icon);

// Frontend overrides for sidebar menu items whose backend-provided icon (item.icon)
// collides with another tool or is not representative. Keyed by the stable menu key
// (from MenuHelper.cs). Falls back to the backend icon when no override is defined.
const menuKeyIconOverrides: Record<string, string> = {
    'pre-designed-templates': 'dashboard_customize',
    fonts: 'text_fields',
    'extra-options': 'extension',
    'profanity-filter-image-moderator': 'shield',
    'minimum-order-quantity': 'production_quantity_limits',
    'get-a-quote': 'request_quote',
    'sales-channels': 'store_alt_solid',
    'integration-settings': 'integration_instructions',
    'general-settings-customizer': 'cog_solid',
    'customizer-ui-settings': 'display_settings'
};

export const GetMenuItemIcon = (item: { key: string; icon: string }) => items.get(menuKeyIconOverrides[item.key] ?? item.icon);
